module.exports = __webpack_public_path__ + "static/img/first-step.5d34659.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduction/first-step.png
// module id = ttn4
// module chunks = 6